import { gql } from '@apollo/client';

export const FIND_WELCOME_MESSAGE_WITH_ALL_LOCALES = gql`
  fragment CommonWelcomeMessageFields on WelcomeMessage {
    id
    title
    subtitle
    bodyText
    locale
    bannerImage {
      id
      url
      formats
    }
    externalBannerImage
  }
  query WelcomeMessagesWithLocales($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      welcomeMessage {
        ...CommonWelcomeMessageFields
        localizations {
          ...CommonWelcomeMessageFields
        }
      }
    }
  }
`;
